import { Injectable } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { take, takeUntil } from "rxjs/operators";
import { FastAccessEnum } from "../../model/fastaccessenum";
import { ItemStateEnum, InvoiceItem, InvoiceStatus, DiscountTypeEnum } from "../../model/invoice.model";
import { OrderService } from "../../order.service";
import { OrderItem } from "../../model/orderItemcategory.model";
import { ActionStateModel } from "../../model/actionstate.model";
import { CustomerFormComponent } from "src/app/frontoffice/parties/customer/customer-form.component";
import { CustomerOrderService } from "../../customerorder/customerorder.service";
import { InvDailyBalanceInhibitorValueEnum } from "src/app/gnr/branch/branch.enum";
import { threadId } from "worker_threads";
@Injectable({ providedIn: "root" })
export class InvoiceService extends BaseService {
  itemStateEnum: typeof ItemStateEnum = ItemStateEnum;

  public fastAccessEnum: typeof FastAccessEnum = FastAccessEnum;

  constructor(public order: OrderService, public customerOrder: CustomerOrderService) {
    super();
    this.fillData();
  }

  fillData() {}

  ngOnInit() {}

  SalePriceChange(event: any) {
    this.order.SalePriceChange(event.Id);
    this.order.invoiceChanged = true;
  }

  clearInvoice() {
    this.order.invoice.Items = null;
    this.order.invoice.Items = [];
    this.order.selectedInvoiceItem = null;
    this.order.invoice.PayableTotal = 0;
    this.order.invoice.TotalDiscount = 0;
    if (this.accountService.authService.currentFiscalYear) this.order.invoice.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) this.order.invoice.FiscalYearId = x.Id;
      });
    if (this.order.selectedOrderItem) this.order.selectedOrderItem.ItemDescription = [];
    this.order.invoice.Discount = 0;
    this.order.invoice.TotalService = 0;
    this.order.invoice.Total = 0;
    this.order.invoice.TotalWidthRowDiscount = 0;
    this.order.invoice.TotalTax = 0;
    this.order.invoice.TotalToll = 0;
    this.order.invoice.TotalNet = 0;
    this.order.invoice.TotalToll = 0;
    this.order.invoice.DiscountPrice = 0;
    this.order.invoice.ServiceTax = 0;
    this.order.invoice.RoundingAmount = 0;
    this.order.setValue("TotalService", null);
    this.order.invoice.PackingPrice = 0;
    this.order.invoice.isPackingDisable = false;
    this.order.setValue("PackingPrice", null);
    this.order.setValue("Debit", null);
    this.order.setValue("Credit", null);
    this.order.setValue("Discount", this.order.invoice.DiscountPrice);
    this.setItemQuantity(undefined, ItemStateEnum.Clear);
    const findDefault = this.order.saleMethodBranch.ItemCategories.find((f) => f.IsDefault);
    if (findDefault) this.order.selectedItemCategory = this.order.itemCategoryList.find((f) => f.Id === findDefault.CategoryId);
    else this.order.selectedItemCategory = Object.assign({}, this.order.itemCategoryList[0]);

    this.order.actionState = new ActionStateModel();
    this.order.formGroup.markAllAsTouched();
    this.order.detectChanges();
    this.order.freeShippingCostDiscount = 0;
    this.order.focus(`Discount`);
    setTimeout(() => {
      this.order.focus(`Code${this.order.invoice.SaleMethodBranchId}`);
    }, 50);
  }
  changeQuantity(item: InvoiceItem, ItemState: ItemStateEnum) {
    let hasNoActionOnQuantity: Boolean = false;
    let qty: number = 0;
    if (item) {
      qty = this.order.formGroup.controls[`itemsQuantity${item.Index}${this.order.invoice.SaleMethodBranchId}`].value;
      if (qty !== item.Quantity && ItemState == ItemStateEnum.NoAction) {
        hasNoActionOnQuantity = true;
        if (qty > item.Quantity) ItemState = ItemStateEnum.Increase;
        else ItemState = ItemStateEnum.Decrease;
      }
      if (!this.order.isLight && (ItemState == ItemStateEnum.Decrease || ItemState == ItemStateEnum.Increase)) {
        const hasDeposit = this.order.currentInformation?.OrderServices && this.order.saleMethodBranch?.HasDeposit;
        const branchId = this.order.invoice.BranchId || this.order.logInBranch.Id;
        const goodsStockInfo = this.order.warehouseStockItems.find(
          (x) =>
            (x.PrevRemainAmount || x.EntryAmount) &&
            x.BranchId === branchId &&
            (x.ItemsInRelation.some((x) => x.Id === item.ItemId) || x.GoodsId === item.GoodsId)
        );

        const goodsFormulaQty =
          (goodsStockInfo?.ItemsInRelation?.some((x) => x.Id === item.ItemId)
            ? goodsStockInfo?.ItemsInRelation.find((x) => x.Id === item.ItemId).DecreaseAmount
            : goodsStockInfo?.DecreaseAmount) ?? 0;

        let quantity = 0;

        if (!!this.order.invoice.Id) {
          const oldQuantity = this.order.invoice.OriginalValue.Items.find((x) => x.Id == item.Id)?.Quantity || 0;
          quantity = (qty - oldQuantity + (ItemState == ItemStateEnum.Decrease ? -1 : +1)) * goodsFormulaQty;
        } else {
          quantity = (qty + (ItemState == ItemStateEnum.Decrease ? -1 : +1)) * goodsFormulaQty;
        }

        if (goodsStockInfo?.Amount < quantity && (!hasDeposit || this.order.invoice?.StatusCode === InvoiceStatus.Ordering)) {
          const notStock = { goodsTitle: goodsStockInfo.GoodsTitle, itemTitle: item.ItemTitle, neededAmount: goodsStockInfo?.Amount - quantity };
          const info =
            "(" +
            notStock.goodsTitle +
            " - " +
            notStock.itemTitle +
            " - " +
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Number") +
            " " +
            notStock.neededAmount +
            ")";
          this.sts.showDialog(
            `
            ${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.FollowingProductUnavailable")}: <br/>
            
            ${info}
            
            `,
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.OutOfStock")
          );
          const branch = this.order.Branches?.find((x) => x.Id === this.order.invoice.BranchId) || this.order.logInBranch;
          if (branch?.InvDailyBalanceInhibitorId === InvDailyBalanceInhibitorValueEnum.Inhibitor) return false;
          if (hasNoActionOnQuantity) {
            this.order.formGroup.controls[`itemsQuantity${item.Index}${this.order.invoice.SaleMethodBranchId}`].setValue(item.Quantity);
          }
        }
      }
    }
    let find_item = -1;
    if (item) find_item = this.order.invoice.Items.findIndex((f) => f.Id === item.Id && f.Index === item.Index);

    switch (ItemState) {
      case ItemStateEnum.Increase:
        if (
          !this.order.HasAccess("PositiveEditOrderingStatus") &&
          !this.order.HasAccess("PositiveEditClearingStatus") &&
          !this.order.HasAccess("PositiveEditClearedStatus") &&
          !this.order.HasAccess("PositiveEditAssignedStatus")
        ) {
          this.sts.showToast(
            "danger",
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.ErrorMessage"),
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.AccessToThisArea")
          );
        } else if (!(find_item < 0)) {
          if (!hasNoActionOnQuantity) this.order.invoice.Items[find_item].Quantity += 1;
          else {
            this.order.invoice.Items[find_item].Quantity = qty;
          }
          this.setItemQuantity(this.order.invoice.Items[find_item], ItemStateEnum.Increase);
        }
        break;
      case ItemStateEnum.Decrease:
        if (
          this.order.HasAccess("NegativeEditOrderingStatus") ||
          this.order.HasAccess("NegativeEditClearingStatus") ||
          this.order.HasAccess("NegativeEditClearedStatus") ||
          this.order.HasAccess("NegativeEditAssignedStatus") ||
          item.State == RowState.New
        ) {
          if (!(find_item < 0)) {
            if (!hasNoActionOnQuantity) this.order.invoice.Items[find_item].Quantity -= 1;
            else {
              this.order.invoice.Items[find_item].Quantity = qty;
            }
            this.setItemQuantity(this.order.invoice.Items[find_item], ItemStateEnum.Decrease);
            if (this.order.invoice.Items[find_item].Quantity === 0) {
              this.setItemQuantity(this.order.invoice.Items[find_item]);
              this.order.invoice.Items.splice(find_item, 1);
              this.changeSelectItem();
              this.setItemQuantity(this.order.invoice.Items[find_item], ItemStateEnum.Decrease);
            }
          }
        } else {
          if (
            this.order.invoice.OriginalValue.Items.find(
              (f) => f.ItemId === this.order.invoice.Items[find_item].ItemId && f.Index === this.order.invoice.Items[find_item].Index
            )?.Quantity < this.order.invoice.Items[find_item].Quantity
          )
            this.order.invoice.Items[find_item].Quantity -= 1;
          else {
            this.sts.showToast(
              "danger",
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.ErrorMessage"),
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.AccessToThisArea")
            );
          }
        }
        break;
      case ItemStateEnum.Remove:
        if (
          !this.order.HasAccess("NegativeEditOrderingStatus") &&
          !this.order.HasAccess("NegativeEditClearingStatus") &&
          !this.order.HasAccess("NegativeEditClearedStatus") &&
          !this.order.HasAccess("NegativeEditAssignedStatus") &&
          item.State !== RowState.New
        ) {
          this.sts.showToast(
            "danger",
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.ErrorMessage"),
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.AccessToThisArea")
          );
        } else if (!(find_item < 0)) {
          this.setItemQuantity(this.order.invoice.Items[find_item], ItemStateEnum.Remove);
          this.order.itemQuantityChanged = true;
          this.order.invoice.Items.splice(find_item, 1);
          this.changeSelectItem();
          if (this.order.invoice.Items.length === 0) this.order.freeShippingCostDiscount = 0;
        }
        if (item.IsClubItem && this.order.invoice.ClubViewModel?.UsedProductDiscount?.length > 0) {
          const find = this.order.invoice.ClubViewModel?.UsedProductDiscount.findIndex((f) => f.ProductId === item.ItemId);
          this.order.invoice.ClubViewModel?.UsedProductDiscount.splice(find, 1);
        }

        break;
      case ItemStateEnum.Clear:
        if (
          !this.order.HasAccess("NegativeEditOrderingStatus") &&
          !this.order.HasAccess("NegativeEditClearingStatus") &&
          !this.order.HasAccess("NegativeEditClearedStatus") &&
          !this.order.HasAccess("NegativeEditAssignedStatus")
        ) {
          this.sts.showToast(
            "danger",
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.ErrorMessage"),
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.AccessToThisArea")
          );
        } else {
          let message = `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.DeleteBasket")}`;
          this.sts.showDialog(message, this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.DeleteCart"), DialogType.confirm, () =>
            this.clearInvoice()
          );
        }
        if (item?.IsClubItem && this.order.invoice.ClubViewModel?.UsedProductDiscount?.length > 0) {
          const find = this.order.invoice.ClubViewModel?.UsedProductDiscount.findIndex((f) => f.ProductId === item.ItemId);
          this.order.invoice.ClubViewModel?.UsedProductDiscount.splice(find, 1);
        }
        break;
    }
    if (this.order.invoice.OriginalValue) {
      let target = this.order.invoice.OriginalValue.Items.find((c) => c.Id === item.Id);
      if (target) {
        if (target.Quantity != item.Quantity) this.order.itemQuantityChanged = true;
        else {
          if (ItemState !== ItemStateEnum.Remove) this.order.itemQuantityChanged = false;
        }
      }
    } else this.order.itemQuantityChanged = true;

    this.order.calculate();
  }

  addFreeCustomer() {
    this.dialogService
      .open(
        CustomerFormComponent,
        {
          label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.SubscriberWithoutNewSubscription"),
          currentrow: { hasAddFastCustomer: true },
          apiName: "Customer",
        },
        { autoFocus: true, closeOnClickOutside: false, closeOnEscape: false }
      )
      .pipe(take(1))
      .subscribe(async (model) => {
        if (model) this.customerOrder.GetCustomerDetails(model.Id, true);
      });
  }
  changeSelectItem() {
    const len = this.order.invoice.Items.length;
    if (len > 0) {
      this.setSelectedItem(this.order.invoice.Items[len - 1], len - 1);
    } else {
      this.order.invoice.TotalService = 0;
      this.order.selectedInvoiceItem = null;
      this.order.selectedOrderItemIndex = null;
      this.order.selectedOrderItem = null;
    }
  }
  /// Whene Selected Item in Invoice
  setSelectedItem(selectedItem: InvoiceItem, index: number) {
    this.order.selectedInvoiceItem = selectedItem;
    this.order.selectedOrderItemIndex = index;
    this.checkDescription();
  }
  /// reset description
  checkDescription() {
    var find_item = this.order?.itemCategoryList[0]?.Items?.find((f) => f.Id === this.order?.selectedInvoiceItem?.ItemId);
    if (!find_item) {
      const findItemHasChild = this.order.itemCategoryList[0].Items.filter((f) => f.ItemChild && f.ItemChild.length > 0);
      if (findItemHasChild) {
        findItemHasChild.forEach((ele) => {
          if (!find_item) find_item = ele.ItemChild.find((f) => f.Id === this.order.selectedInvoiceItem.ItemId);
        });
      }
    }

    find_item?.ItemDescription?.forEach((f) => {
      if (this.order.selectedInvoiceItem.Descriptions.some((s) => s.DescriptionId === f.Id)) f.IsSelected = true;
      else f.IsSelected = false;
    });
    find_item?.Additive?.forEach((f) => {
      if (this.order.selectedInvoiceItem.Additives.some((s) => s.AdditiveId === f.Id)) f.IsSelected = true;
      else f.IsSelected = false;
    });
    if (find_item) {
      const findItem: OrderItem = JSON.parse(JSON.stringify(find_item));
      findItem.ItemDescription = findItem.ItemDescription?.filter((x) => x.BranchId === this.order.invoice.BranchId) || [];
      findItem.Additive = findItem.Additive?.filter((x) => x.Branches.some((x) => x === this.order.invoice.BranchId)) || [];
      this.order.selectedOrderItem = findItem;
    }
    this.order.SalePriceChange(this.order.invoice.SalePriceTypeId);
  }
  changeNumberOfGuests(state: number) {
    this.order.invoiceChanged = true;
    this.order.itemChanged = true;
    if (this.order.formGroup.controls["NumberOfGuests"].value)
      this.order.invoice.NumberOfGuests = this.order.formGroup.controls["NumberOfGuests"].value;
    if (state === 1) this.order.invoice.NumberOfGuests += 1;
    else {
      if (this.order.invoice.NumberOfGuests !== 0) this.order.invoice.NumberOfGuests -= 1;
    }
    this.order.formGroup.controls["NumberOfGuests"].setValue(this.order.invoice.NumberOfGuests);
    this.order.checkInvoiceState(this.order.invoice.CommandCode);
    this.order.detectChanges();
  }

  OnChangedDescription(event: any, controlName: string) {
    const inputValue = event.target.value;
    this.order.invoice[controlName] = inputValue;
    this.order.invoiceChanged = true;
    this.order.checkInvoiceState(this.order.invoice.CommandCode);
  }

  //جهت نمایش صفحه گارسون ها در دسترسی سریع
  openFastAccess(value: FastAccessEnum, event?: Event) {
    event.stopPropagation();
    setTimeout(() => {
      this.order._opened = true;
      this.order.selectedFastAccess = value;
      this.order.detectChanges();
    }, 50);
  }
  //حذف گارسون
  DeleteWaiter() {
    this.order.invoice.WaiterId = null;
    this.order.invoice.WaiterName = null;
    this.order.invoiceChanged = true;
  }
  //حذف مشتری
  DeleteCustomer() {
    this.order.invoice.CustomerId = null;
    this.order.invoice.CustomerDisplayName = null;
    this.order.invoice.CustomerName = null;
    this.order.invoice.CustomerAddress = null;
    this.order.invoice.PhoneId = null;
    this.order.invoice.PhoneNumber = null;
    this.order.invoice.Customer = null;
    this.order.invoiceChanged = true;
  }
  setItemQuantity(invoiceItem: InvoiceItem, ItemState?: ItemStateEnum) {
    this.addRowDiscount();
    if (!this.order.common.isMobileMode && !this.order.common.isDigitalMenu) return;
    this.order.itemCategoryList.forEach((element) => {
      element.Items.forEach((item) => {
        if (item.Id === invoiceItem?.ItemId || ItemState === ItemStateEnum.Clear) {
          item.InvoiceQty = invoiceItem && (ItemState === ItemStateEnum.Increase || ItemState === ItemStateEnum.Decrease) ? invoiceItem.Quantity : 0;
          this.order.setValueQuantity();
        } else {
          if (item.ItemChild && item.ItemChild.length > 0) {
            //const find = item.ItemChild.find(f => f.Id === invoiceItem?.CategoryId);
            const findchild = item?.ItemChild?.find((f) => f.Id === invoiceItem?.ItemId && f.BranchId === invoiceItem?.BranchId);
            if (findchild) {
              item.InvoiceQty =
                invoiceItem && (ItemState === ItemStateEnum.Increase || ItemState === ItemStateEnum.Decrease) ? invoiceItem.Quantity : 0;
              if (this.order.itemHasParent) {
                this.order.itemHasParent.find((f) => f.Id === invoiceItem?.ItemId).InvoiceQty =
                  invoiceItem && (ItemState === ItemStateEnum.Increase || ItemState === ItemStateEnum.Decrease) ? invoiceItem.Quantity : 0;
              } else {
                console.log(invoiceItem);
              }

              this.order.setValueQuantity();
            }
          }
        }
      });
    });
    this.order.detectChanges();
  }
  // Add RowDiscount
  addRowDiscount() {
    this.order.invoice.Items.forEach((f) => {
      if (!this.order.formGroup.controls[`RowDiscount${f.Index}${this.order.invoice.SaleMethodBranchId}`]) {
        this.order.formGroup.addControl(`RowDiscount${f.Index}${this.order.invoice.SaleMethodBranchId}`, new UntypedFormControl(f.RowDiscount));
      } else {
        this.order.formGroup.controls[`RowDiscount${f.Index}${this.order.invoice.SaleMethodBranchId}`].setValue(
          this.order.formGroup.controls[`RowDiscount${f.Index}${this.order.invoice.SaleMethodBranchId}`].value
        );
      }
      if (f.Id && f.Id !== 0) f.State = RowState.Modify;
    });

    this.order.detectChanges();
  }
  // حذف توضیح ها
  clearDescription(item: InvoiceItem) {
    item.Description = "";

    if (this.order.selectedInvoiceItem) {
      this.order.selectedInvoiceItem.Descriptions = [];
      this.order.selectedInvoiceItem.Additives = [];
    }

    this.order.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).Additives = [];
    this.order.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).Descriptions = [];
    this.order.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).Description = "";
    const findItemSelected = this.order.selectedItemCategory.Items.find((f) => f.Id === item.ItemId);
    findItemSelected?.Additive?.forEach((f) => {
      f.IsSelected = false;
    });
    findItemSelected?.ItemDescription?.forEach((f) => {
      f.IsSelected = false;
    });

    //}

    this.setSelectedItem(this.order.selectedInvoiceItem, this.order.selectedOrderItemIndex);
    this.order.itemChanged = true;
    this.order.calculate();
  }
  // تخفیفات ردیفی
  RowDiscountChange(value) {
    if (
      (this.order.invoice.Items.find((f) => f.Index === value).RowDiscount !==
        Number(this.order.formGroup.controls[`RowDiscount${value}${this.order.invoice.SaleMethodBranchId}`].value) &&
        this.order.invoice.Items.find((f) => f.Index === value).RowDiscount > 0) ||
      (this.order.formGroup.controls[`RowDiscount${value}${this.order.invoice.SaleMethodBranchId}`].value > 0 &&
        this.order.invoice.Items.find((f) => f.Index === value).RowDiscount !==
          Number(this.order.formGroup.controls[`RowDiscount${value}${this.order.invoice.SaleMethodBranchId}`].value))
    ) {
      if (this.order.invoice.Items.find((f) => f.Index === value).Id && this.order.invoice.Items.find((f) => f.Index === value).Id !== 0) {
        this.order.invoice.Items.find((f) => f.Index === value).State = RowState.Modify;
      }
      if (
        this.order.currentUser.PercentDiscount > 0 &&
        this.order.formGroup.controls[`RowDiscount${value}${this.order.invoice.SaleMethodBranchId}`].value > this.order.currentUser.PercentDiscount
      ) {
        this.order.setValue(`RowDiscount${value}${this.order.invoice.SaleMethodBranchId}`, this.order.currentUser.PercentDiscount);
      }

      this.order.invoiceChanged = true;

      this.order.calculate();
    }
  }
  ShowRowDiscount(item) {
    item.showPercent = !item.showPercent;
    this.order.detectChanges();
    if (item?.showPercent) this.order.focus(`RowDiscount${item.Index}${this.order.invoice.SaleMethodBranchId}`);
    if (!this.order.HasAccess("GiveDiscount")) {
      item.showPercent = false;
      this.order.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.AccessToThisArea"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Attention")
      );
    }
  }
  closeHeader() {
    this.order.showHeader = false;
  }
  clearRowDiscount() {
    this.order.setValue(`RowDiscount${this.order.invoice.SaleMethodBranchId}`, 0);
    this.order.invoiceChanged = true;
    this.order.calculate();
  }
}
